import React from 'react';
import WidgetLoadingIndicator from './WidgetLoadingIndicatorComponent.jsx';

class InstantWidgetComponent extends React.Component {
	render() {
		let isLoading = this.props.isLoading;
		let isEnded = this.props.isEnded;
		let isDataSourceBroken = this.props.isDataSourceBroken;

		const styleAbsolute = {position: 'absolute', top: 0, bottom: 0, left: 0, right: 0};

		if(isEnded) {
			return (
				<div style={styleAbsolute}>
					<div className="widget-container"></div>
					<WidgetLoadingIndicator isEnded={true}>stream ended</WidgetLoadingIndicator>
				</div>
			)
		}else if(isLoading) {
			return (
				<div style={styleAbsolute}>
					<div className="widget-container"></div>
					<WidgetLoadingIndicator></WidgetLoadingIndicator>
				</div>
			)
		}else if(isDataSourceBroken) {
			return (
				<div style={styleAbsolute}>
					<div className="widget-container"></div>
					<div className="widget-disabled"></div>
					<WidgetLoadingIndicator isEnded={true}>datasource broken</WidgetLoadingIndicator>
				</div>
			)
		}else {
			return (
				<div style={styleAbsolute}>
					<div className="widget-container"></div>
				</div>
			)
		}
	}
}

export default InstantWidgetComponent;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/InstantWidgetComponent.jsx